<script setup lang="ts">
import TooltipPositionEnum from '@/domains/common/typescript/TooltipPositionEnum';
import { ref, useTemplateRef } from 'vue';

withDefaults(
    defineProps<{
        optionnal?: boolean;
        target: string;
        tooltipText?: string;
        tooltipPosition?: TooltipPositionEnum;
    }>(),
    {
        optionnal: false,
        tooltipText: undefined,
        tooltipPosition: TooltipPositionEnum.TOP,
    },
);

const tooltipActivatorRef = useTemplateRef('tooltipActivator');
const isTooltipVisible = ref(false);
</script>
<template>
    <div
        class="flex flex-row items-center gap-2"
        @mouseenter="isTooltipVisible = true"
        @mouseleave="isTooltipVisible = false"
    >
        <label :for="target" class="text-input-label">
            <slot />
        </label>
        <span v-if="optionnal" class="text-info-text text-sm lowercase italic">
            {{ $t('global.optional') }}
        </span>
        <span
            v-if="tooltipText"
            ref="tooltipActivator"
            class="border-theme-black flex h-3 w-3 items-center justify-center rounded-full border text-center text-xs select-none hover:cursor-pointer"
        >
            ?
        </span>
        <BaseTooltip
            v-if="tooltipText && tooltipActivatorRef"
            :parent="tooltipActivatorRef"
            :visible="isTooltipVisible"
            :position="tooltipPosition"
        >
            {{ tooltipText }}
        </BaseTooltip>
    </div>
</template>
